"use client";

import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";

export function usePortal(id: string): HTMLDivElement | undefined {
  const rootElemRef = useRef(typeof document === "undefined" ? undefined : document.createElement("div"));

  useEffect(() => {
    const parentElem = document.getElementById(id);
    if (!rootElemRef.current || !parentElem) {
      return;
    }

    for (const child of parentElem?.childNodes || []) {
      parentElem?.removeChild(child);
    }

    parentElem.appendChild(rootElemRef.current);
    parentElem.style.display = "block";
    return () => {
      rootElemRef.current?.remove();
      if (parentElem?.childNodes.length == 0) {
        parentElem.style.display = "none";
      }
    };
  }, [id]);

  return rootElemRef.current;
}

export function renderInPortal(target: HTMLDivElement | undefined, content: React.ReactNode | (() => React.ReactNode)) {
  if (!target) {
    return null;
  }
  const actualContent = typeof content == "function" ? content() : content;
  return ReactDOM.createPortal(actualContent, target);
}
